import { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { createSliceWithStateReset } from 'store/createSliceWithStateReset';
import { NavigationTab } from './types';

const initialState: { navigationTab: NavigationTab | null } = {
  navigationTab: null,
};

const navigationSlice = createSliceWithStateReset({
  name: 'navigation',
  initialState,
  reducers: {
    setNavigationTab: (state, action: PayloadAction<NavigationTab | null>) => ({
      ...state,
      navigationTab: action.payload,
    }),
  },
});

export const { setNavigationTab } = navigationSlice.actions;
export const selectNavigationTab = (state: RootState) => state.navigation.navigationTab;
export const { reducer: navigationReducer } = navigationSlice;
